import React from 'react'
import _ from 'underscore'
import { Mail } from 'lucide-react'
import { Button } from '@/components/ui/button'

class EmailButton extends React.Component {

  onNewDraftClick = () => {
    this.props.onEmail()
  }

  render() {
    return (
      <Button size="sm" variant="outline" title="Send Email" onClick={this.onNewDraftClick}>
        <Mail className="size-4" />
      </Button>
    )
  }
}

export default EmailButton
